import { useParams } from "next/navigation"

export default useParams
